// These should be the ones available in the environment yaml files found in
// /packages/atgse/dev-server/dev_environment_variables/

export const loginTimeLimit = "loginTimeLimit";
export const reduxLogger = "reduxLogger";
export const sportUseProdData = "sportUseProdData";
export const sportUseProdCloudfront = "sportUseProdCloudfront";
export const shortRealityCheck = "shortRealityCheck";
export const scopeDebugger = "scopeDebugger";

export const reduxDevTools = "reduxDevTools";

/**
 * The trace functionality in redux dev tools affects performance, thus it's optional.
 */
export const activateReduxTrace = "activateReduxTrace";

/**
 * A tool to help go into the limbo mode: the mode where the
 * frontend thinks that the user is logged in but it's not on the backend
 */
export const limboDebugger = "limboDebugger";

export const personalPush = "personalPush";
export const pushNotification = "pushNotification";

/**
 * @deprecated DO NOT USE! This feature flag is kept temporarily only to ensure backwards compatibility with newer version of server together with older versions of horse microFE
 * TODO: remove once horse has been released with a version that no longer references this feature toggle and there is NO RISK of rollback
 *  A toggle to enable the new startlist (will be placed on the starlist)
 */
export const newStartlist = "newStartlist";

/**
 * @deprecated
 * TODO: Remove when horse is released without dependency on it
 */
export const bettingTrends = "bettingTrends";

/**
 * Enable self-exclusions RGS endpoint
 * @deprecated DO NOT USE! This feature flag is kept temporarily only to ensure backwards compatibility with newer version of server together with older versions of client microFE:s
 * TODO: remove once all microFE:s have been released with a version that no longer references this feature toggle
 */
export const selfExclusionsRGS = "selfExclusionsRGS";

/**
 * [ATGSEDIG-37767] change RGS net loss limit endpoint
 * @deprecated DO NOT USE! This feature flag is kept temporarily only to ensure backwards compatibility with newer version of server together with older versions of client microFE:s
 * TODO: remove once all microFE:s have been released with a version that no longer references this feature toggle
 */
export const newRgsLimitService = "newRgsLimitService";

/**
 * add a possibility to enable apollo dev tools in qa or even prod
 */
export const apolloDevTools = "apolloDevTools";

/**
 * [ATGSEDIG-37887] enable or disable kycQuestionnaire
 */
export const kycQuestionnaire = "kycQuestionnaire";

/**
 * The big migration from the old HBH rest way to the new CBH graphql way to place and view bets. It involves changes in "mina spel" page and in the placement of a bet.
 */
export const varenne = "varenne";

export const abTestOverlay = "abTestOverlay";

/**
 * Enable experimental category system for play
 */
export const playExperimental = "playExperimental";

/**
 * Mock requests with MSW
 */
export const mockRequestsWithMSW = "mockRequestsWithMSW";

/**
 * Enable debugger for horse mina spel.
 */
export const minaSpelDebugger = "minaSpelDebugger";

/**
 * Enable route for julkalender page.
 */
export const julkalender = "julkalender";

/**
 * Session timer
 */
export const sessionTimer = "sessionTimer";

/**
 * Shorten login reminder snackbar from 35 min -> 10 min
 */
export const shortLoginReminder = "shortLoginReminder";

/*
 * Enable route for Horse Of The Year page (/aretshast)
 */
export const horseOfTheYearPage = "horseOfTheYearPage";

/*
 * Enable detachedMiniPlayer for play vertical
 */
export const loseMiniPlayer = "loseMiniPlayer";

/*
 * Enable latest version of aws serverless image handler
 */
export const newImageHandler = "newImageHandler";

/*
 * Avoid permanent redirect from atg.se to Tillsammans
 */
export const avoidPermanentTillsammansRedirect = "avoidPermanentTillsammansRedirect";

/**
 * Enable Tillsammans file uploads by REST API
 */
export const tillsammansRestFileUploads = "tillsammansRestFileUploads";

/*
 * Turn off tillsammans push
 */
export const tillsammansPush = "tillsammansPush";

/*
 * Enable NPS survey to be shown in Tillsammans
 */
export const npsEnabled = "npsEnabled";

/**
 * Enable tillsammans private shares marketplace
 *
 */
export const tillsammansMarketplace = "tillsammansMarketplace";

/**
 * Enable tillsammans private shares marketplace additions
 *
 */
export const tillsammansMarketplaceAdditions = "tillsammansMarketplaceAdditions";

/*
 * Enable to save last known vertical to localstorage
 */
export const lastVertical = "lastVertical";

/**
 * ATGSEDIG-56398 Enable to use new rcs endpoint for Optins.
 * @deprecated DO NOT USE! This feature flag is kept temporarily only to ensure backwards compatibility with newer version of server together with older versions of client microFE:s
 * TODO: remove once all microFE:s have been released with a version that no longer references this feature toggle
 */
export const rcsOptins = "rcsOptins";

/**
 * @deprecated DO NOT USE! This feature flag is kept temporarily only to ensure backwards compatibility with newer version of server together with older versions of client microFE:s
 * TODO: remove once all microFE:s have been released with a version that no longer references this feature toggle
 */
export const newJackpot = "newJackpot";

/*
 * Enable route for rg microFE (/rg)
 */
export const rgMicroFe = "rgMicroFe";

/*
 * Enables the toggle for the new mini player
 */
export const newMiniPlayer = "newMiniPlayer";

/*
 * Enables the toggle for the new mini player
 */
export const closeMenuOnVerticalClick = "closeMenuOnVerticalClick";

/*
 * Enable to keep save last known vertical to localstorage only if it's Tillsammans
 */
export const lastVerticalTillsammans = "lastVerticalTillsammans";

/**
 * Enable new API driven Curity flow (replacing iframe)
 */
export const newCurityFlow = "newCurityFlow";

/*
 * Enables the old top menu in mobile
 */
export const mobileTopMenu = "mobileTopMenu";

/*
 * Enables the toggle for the new play top section
 */
export const newPlayTopSection = "newPlayTopSection";

/*
 * Enables the toggle for the new search bar in the news archive page (/nyheter)
 */
export const newsArchiveSearch = "newsArchiveSearch";

/*
 * Enables the toggle for using the max stake per system for the shopshare bets
 */
export const useMaxStakePerSystem = "useMaxStakePerSystem";

/** *************************************************************************
 *                                                                          *
 *     Enables the toggle for the context using Enhanced live reducer       *
 *                                                                          *
 * ************************************************************************ */
export const liveChannelsContext = "liveChannelsContext";
export const liveChatContext = "liveChatContext";

/*
 * Enables the toggle for using the deposit v2 endpoint for credit card
 */
export const depositV2CreditCard = "depositV2CreditCard";

/*
 *  Enables the toggle for the new micro frontend video player
 */
export const microFrontendVideoPlayer = "microFrontendVideoPlayer";

/*
 *  Enables the toggle for the new live chat in the videoframe (livebar)
 */
export const liveChatStreaming = "liveChatStreaming";

/*
 *  Enables the toggle for showing all chat history when joining a live chat stream
 */
export const liveChatStreamingAllHistory = "liveChatStreamingAllHistory";

/*
 * Enables the use of the finnish haapi client id
 */
export const haapiClientIdFinland = "haapiClientIdFinland";

/*
 * Enables the toggle to use more vindral channels ("Förbättrad live" video, used in live player)
 */
export const moreVindralChannels = "moreVindralChannels";

/*
 * Enables the toggle for common items in Navbar
 */
export const commonItems = "commonItems";

/*
 * Enables the debugger for sports vertical
 */
export const sportsDebugger = "sportsDebugger";

/**
 * Enables React 18 concurrent mode
 */
export const react18ConcurrentMode = "react18ConcurrentMode";

/**
 * Enables V85 to replace V75 in the horse vertical in some static instances
 */
export const newV85GameType = "newV85GameType";

/**
 * Enables v2 member auth api
 */
export const v2MemberAuthApi = "v2MemberAuthApi";

/*
 * Enables RaceArchive highlights in startlist [Horse Digital - Team Engage]
 */
export const raceArchiveHighlights = "raceArchiveHighlights";

/**
 * Enables language code in URL for markets with multiple languages
 */
export const languageCodeInUrl = "languageCodeInUrl";

/**
 * Enabled App OneLink for mobile app for deep linking
 */
export const appUseOneLink = "appUseOneLink";

/*
 * Enables the toggle for the hts radar/följ spel in the live player
 * https://atgse.atlassian.net/jira/software/c/projects/ENGAGE/boards/901?selectedIssue=ENGAGE-118
 */
export const radar = "radar";

/*
 * Enables the toggle for the hts radar/följ spel debugger in live player
 */
export const radarDebugger = "radarDebugger";

/**
 * Enables withdrawals in modal instead of full page
 */
export const withdrawalsInModal = "withdrawalsInModal";

/*
 * Enables tanstack devtools in horse vertical
 */
export const horseTanstackDevTools = "horseTanstackDevTools";

/*
 * Enable the toggle for the new version of shopshare page
 */
export const newShopSharePage = "newShopSharePage";

/*
 * Enables the learnster responsible gaming education for game initiators
 */
export const learnsterResponsibleGaming = "learnsterResponsibleGaming";

/**
 *Enables launch campaign modal on start page
 */
export const launchCampaignModal = "launchCampaignModal";

/**
 * Enables Tanstack React Query Devtools in sports vertical
 */
export const sportTanstackReactQueryDevtools = "sportTanstackReactQueryDevtools";

/**
 * Enables new email verification flow
 */
export const newEmailVerificationFlow = "newEmailVerificationFlow";

/**
 * Enables frontend rendering for message templates in customer inbox
 */
export const frontendMessageTemplates = "frontendMessageTemplates";

/**
 * Enables fast polling for Swish Direct payments
 */
export const paymentSwishDirectFastPolling = "paymentSwishDirectFastPolling"
